// @flow
import CCActionTypes from '../action-types/cc-mode';

import type { CCMode, Notification } from '../types/cc-mode';

export interface State {
  ccMode: CCMode | typeof undefined;
  notifications: Notification[];
  showBubbleAboveCCMode: boolean;
}

const INITIAL_STATE: State = {
  ccMode: undefined,
  notifications: [],
  showBubbleAboveCCMode: false,
};

const ccModeReducer = (state: State = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case CCActionTypes.ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    case CCActionTypes.CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      };
    case CCActionTypes.DELETE_NOTIFICATION:
      return {
        ...state,
        notifications: [
          ...state.notifications.slice(0, action.payload),
          ...state.notifications.slice(action.payload + 1),
        ],
      };
    case CCActionTypes.SET_MODE:
      return {
        ...state,
        ccMode: action.payload,
      };
    case CCActionTypes.SET_SHOW_BUBBLE_ABOVE_CC_MODE:
      return {
        ...state,
        showBubbleAboveCCMode: action.payload,
      };
    default:
      return state;
  }
};

export default ccModeReducer;
